import TheGrid from '@/views/products/shoppinggroups/grid'
import Edit from '@/views/products/shoppinggroups/edit'

export default {
  path: '/products/shoppinggroups',
  redirect: '/products/shoppinggroups/index',
  name: 'shoppinggroups',
  meta: {
    auth: {
      redirect: {
        name: 'shoppinggroups.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Produtos'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'shoppinggroups.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'shoppinggroups.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'shoppinggroups.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
